import { useDispatch, useSelector } from 'react-redux'
import SelectBox from 'components/form/SelectBox'
import { selectGroup } from 'features/editlog/editlogSlice'
import { isEmpty } from 'utils'

const GroupFilter = () => {
  const dispatch = useDispatch()
  const { groups, selectedCampaign, selectedGroup, isLoading } = useSelector(
    state => state.editlog
  )

  return (
    <SelectBox
      placeholder="그룹 선택"
      value={selectedGroup}
      onValueChange={v => dispatch(selectGroup(v))}
      disabled={!selectedCampaign || isEmpty(groups) || isLoading}>
      {groups.map(group => (
        <SelectBox.Item key={group.id} value={group}>
          {group.name} {group.deletedDate && '(삭제)'}
        </SelectBox.Item>
      ))}
    </SelectBox>
  )
}

export default GroupFilter

GroupFilter.propTypes = {}
